import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { findOneBusinessEntry, DEFAULT_FIELD_EXCEPTIONS } from "../../../services/content/business.lib.js";
import { isVisibleOnWeb } from "../../../utils/contentstack/webApplicability.js";
import { RichTextEntryClient } from "./RichTextEntryClient.js";
async function RichTextEntry({
  entryId,
  locale,
  enableLivePreview
}) {
  var _a;
  const entry = await findOneBusinessEntry(
    ContentType.CustomRichText,
    entryId,
    locale,
    DEFAULT_FIELD_EXCEPTIONS,
    enableLivePreview
  );
  if (!entry) {
    return null;
  }
  if (!isVisibleOnWeb(entry)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    RichTextEntryClient,
    {
      entryId,
      rich_text_editor: entry.rich_text_editor,
      ad_type: (_a = entry == null ? void 0 : entry.component_size) == null ? void 0 : _a.ad_type
    }
  );
}
export {
  RichTextEntry
};
